import React from 'react'
import { ControlledSelectField } from '../ControlledSelectField'

export const BudgetRangeSelect = () => {
  const rangeMenuItems = [
    { value: 'Below 500K', label: 'Below 500K' },
    { value: '500K to 1M', label: '500K to 1M' },
    { value: '1M to 3M', label: '1M to 3M' },
    { value: '3M to 5M', label: '3M to 5M' },
    { value: 'Above 5M', label: 'Above 5M' },
    { value: 'Open Budget', label: 'Open Budget' }
  ]

  return (
    <ControlledSelectField
      name='campaign.budget'
      label='Budget'
      menuItems={rangeMenuItems}
    />
  )
}
